type LogLevel = 'warn' | 'error'

const originalConsole = {
  warn: console.warn.bind(console),
  error: console.error.bind(console)
}

const redactPatterns = [
  /(Bearer\s+)[A-Za-z0-9._-]+/gi,
  /((password|passwd|pwd|token|secret|authorization|jwt|key)=)[^&\s]+/gi
]

let installed = false

function redact(text: string) {
  return redactPatterns.reduce((value, pattern) => value.replace(pattern, '$1[REDACTED]'), text)
}

function toText(value: unknown): string {
  if (value instanceof Error) {
    return value.stack || value.message
  }
  if (typeof value === 'string') {
    return value
  }
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}

function stackLocation(stack?: string) {
  const line = stack
    ?.split('\n')
    .map((item) => item.trim())
    .find((item) => item && !item.includes('logger.ts'))
  return line || 'unknown'
}

function writeLog(level: LogLevel, type: string, values: unknown[], error?: Error) {
  const stack = error?.stack || new Error().stack
  const message = redact(values.map(toText).join(' '))
  originalConsole[level](`[${level}]`, {
    type,
    message,
    location: stackLocation(stack),
    stack: redact(stack || '')
  })
}

export function installFrontendLogging() {
  if (installed) return
  installed = true

  console.warn = (...values: unknown[]) => writeLog('warn', 'console.warn', values)
  console.error = (...values: unknown[]) => {
    const error = values.find((value): value is Error => value instanceof Error)
    writeLog('error', 'console.error', values, error)
  }

  window.addEventListener('error', (event) => {
    const error = event.error instanceof Error ? event.error : undefined
    writeLog('error', 'window.error', [event.message], error)
  })

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason instanceof Error ? event.reason : new Error(toText(event.reason))
    writeLog('error', 'unhandledrejection', [reason], reason)
  })
}
